import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UpgradeModal from './UpgradeModal';

const GlobalPrompts = () => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    useEffect(() => {
        // Exclude Home Page from prompts
        if (location.pathname === '/') return;

        // Logic to triggering the Upgrade Modal
        // 1. User must be logged in
        // 2. User must be on 'free' tier 
        // 3. Trigger on EVERY mount (refresh/navigation that remounts app)
        // 4. Trigger Randomly (Periodic)
        // 5. Manual triggers via event

        let randomTimer;

        const checkAndShow = () => {
            // All automatic popups have been removed. We only react to the 'trigger-upgrade-modal' event now.
        };

        const cleanup = checkAndShow();

        // Listen for manual triggers (e.g. from Generator button)
        const handleManualTrigger = () => {
            if (isAuthenticated && user) {
                const userTier = user.subscription_tier || 'free';
                if (userTier === 'free') {
                    setShowUpgradeModal(true);
                }
            }
        };

        window.addEventListener('trigger-upgrade-modal', handleManualTrigger);

        return () => {
            if (cleanup && typeof cleanup === 'function') cleanup();
            if (randomTimer) clearTimeout(randomTimer);
            window.removeEventListener('trigger-upgrade-modal', handleManualTrigger);
        };

    }, [isAuthenticated, user]);

    const handleClose = () => {
        setShowUpgradeModal(false);
        // Dispatch event so listeners know the user has responded/closed it
        window.dispatchEvent(new Event('upgrade-modal-closed'));
    };

    return (
        <>
            <UpgradeModal
                isOpen={showUpgradeModal}
                onClose={handleClose}
            />
        </>
    );
};

export default GlobalPrompts;
